import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingOverlay from '../pages/LoadingOverlay';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  // 인증 상태 로딩 중일 때
  if (loading) {
    return <LoadingOverlay />;
  }

  // 인증되지 않은 경우 로그인 페이지로 리다이렉트
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 특정 역할이 필요한 경우 권한 체크
  if (requiredRole && user?.role !== requiredRole) {
    return (
      <div className="unauthorized-container">
        <div className="unauthorized-content">
          <h1>접근 권한이 없습니다</h1>
          <p>이 페이지에 접근할 권한이 없습니다.</p>
          <button onClick={() => window.history.back()} className="back-btn">
            돌아가기
          </button>
        </div>
      </div>
    );
  }

  // 인증되고 권한이 있는 경우 자식 컴포넌트 렌더링
  return children;
};

export default ProtectedRoute;